/** Router state handed to /login so it can confirm what just happened on the previous page. */
export const PASSWORD_UPDATED_STATE = { notice: 'password-updated' } as const;

export function isPasswordUpdatedState(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    'notice' in state &&
    state.notice === PASSWORD_UPDATED_STATE.notice
  );
}
